import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconDefaultAiAgentFab",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6 2a4 4 0 0 0 0 8h4.5a.5.5 0 1 1 0 1H6a5 5 0 1 1 4.167-2.235.5.5 0 1 1-.833-.553A4 4 0 0 0 6 2Zm2.3 5.1a.5.5 0 0 1 .1.7A2.996 2.996 0 0 1 6 9a2.996 2.996 0 0 1-2.4-1.2.5.5 0 1 1 .8-.6c.366.487.946.8 1.6.8.654 0 1.235-.313 1.6-.8a.5.5 0 0 1 .7-.1Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function f(e, m, i, h, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--default-ai-agent-fab"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Default Ai Agent Fab",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const v = /* @__PURE__ */ o(s, [["render", f]]);
export {
  v as default
};
//# sourceMappingURL=default-ai-agent-fab.js.map
